/**
 * Interface pro rozsireni vstupu filtrovani, pokud je zadano, pouziva se jina nez hlavni oparace (vyuzito na DateTimeWithInclude)
 */
export interface IWithInclude {
    include: boolean;
    includeVisible: boolean;
}

export class IWithInclude {
    private static _properties: (keyof IWithInclude)[] = ["include", "includeVisible"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}
